import { withTheme } from 'styled-components';

import { TariffDirection } from '../../../api/Optimise';
import type { Theme } from '../../../theme/themes/ThemeTypes';
import type { ChartDataItem } from '../../../types/charts';
import formatDate from '../../../utils/formatDate';
import textOrPlaceholder from '../../../utils/textOrPlaceholder';

import Chart from './Chart';
import Container from './Styled/Container';
import H3 from './Styled/H3';

interface ImportSavingsChartProps {
  chartData?: ChartDataItem[];
  date: string;
  theme: Theme;
}

const ImportSavingsChart = ({ chartData, date, theme }: ImportSavingsChartProps) => {
  const importKey = 'actual_import_cost';

  // Change import cost to a positive number so the bars go upwards
  const data = chartData?.map((row) => ({
    ...row,
    [importKey]: row[importKey] * -1,
    time: row.time,
  }));

  const importCosts = data ? data?.reduce((acc, row) => acc + row[importKey], 0) / 100 : 0;

  const dataAvailable = data?.some((row) => row[importKey] > 0);

  return (
    <Container>
      <H3 typeColour={theme.colors.imported}>
        Grid <span className="type">import</span> costs on {formatDate(date)}:{' '}
        <span className="cost">£{textOrPlaceholder(importCosts, importCosts?.toFixed(2))}</span>
      </H3>
      {/* @ts-ignore */}
      <Chart
        data={data}
        dataKey={importKey}
        barColor={theme.colors.imported}
        yAxisLabel="Import costs"
        xAxisLabel="Time of day"
        dataAvailable={dataAvailable}
        direction={(TariffDirection as any).IMPORT}
      />
    </Container>
  );
};

export default withTheme(ImportSavingsChart as any);
